module.exports = __webpack_public_path__ + "img/products-taptab-thumbnail.a918ab91.jpg";